// Datos dummy mientras se integra el endpoint del reporte de registro de huéspedes.
import {
    ConteoPorValor,
    Dashboard,
    GeneroHuesped,
    TablaRegistroHuesped,
    TipoDocumentoHuesped,
    TipoHuesped,
} from "./RegistroHuespedes.type"

const NOMBRES = [
    "Estefanía Molina",
    "Carlos Ramírez",
    "María Fernanda López",
    "Jorge Hernández",
    "Valeria Torres",
    "Luis Alberto Gómez",
    "Sofía Martínez",
    "Diego Castillo",
    "Ana Paula Ruiz",
    "Ricardo Vargas",
]

const NACIONALIDADES = ["Mexicana", "Mexicana", "Mexicana", "Mexicana", "Argentina", "Española"]

const HABITACIONES = [
    "Suite Jacuzzi 201",
    "Suite Villa 101",
    "Sky Suite 704",
    "Sky Suite 705",
    "Suite Junior 201",
    "Suite Villa 301",
]

const GENEROS = [GeneroHuesped.masculino, GeneroHuesped.femenino, GeneroHuesped.no_binario]

const TIPOS_HUESPED = [TipoHuesped.titular, TipoHuesped.adicional, TipoHuesped.adicional, TipoHuesped.extra]

const TIPOS_DOCUMENTO = [
    TipoDocumentoHuesped.ine,
    TipoDocumentoHuesped.ine,
    TipoDocumentoHuesped.pasaporte,
    TipoDocumentoHuesped.licencia,
    TipoDocumentoHuesped.otro,
]

const TOTAL_DUMMY = 47

const pick = <T>(list: T[], i: number) => list[i % list.length]

export const registroHuespedesDummy: TablaRegistroHuesped[] = Array.from({ length: TOTAL_DUMMY }, (_, i) => {
    const tipoDocumento = pick(TIPOS_DOCUMENTO, i)
    // Los registros con documento "Otro" simulan huéspedes con datos incompletos
    const sinDatos = tipoDocumento === TipoDocumentoHuesped.otro
    const dia = String((i % 28) + 1).padStart(2, "0")

    return {
        registro_id: `reg-${i + 1}`,
        folio_ticket: `HO-${String(Math.floor(i / 3) + 1).padStart(2, "0")}0226`,
        tipo_huesped: i % 3 === 0 ? TipoHuesped.titular : pick(TIPOS_HUESPED, i),
        genero: sinDatos ? null : pick(GENEROS, i),
        nombre: pick(NOMBRES, i),
        fecha_nacimiento: sinDatos ? null : `${dia}/${String((i % 12) + 1).padStart(2, "0")}/${1970 + (i % 30)}`,
        nacionalidad: sinDatos ? null : pick(NACIONALIDADES, i),
        tipo_documento: tipoDocumento,
        numero_documento: sinDatos
            ? null
            : tipoDocumento === TipoDocumentoHuesped.pasaporte
            ? `J0000000${i % 10}`
            : `GMVLMR800705${String(i).padStart(2, "0")}M100`,
        curp: sinDatos ? null : `GOVM800705MCLMLR${String(i % 10).padStart(2, "0")}`,
        direccion: sinDatos ? null : "Viad. Tlalpan 100 Col. Arenal Tepepan, Tlalpan, CDMX",
        fecha_entrada: "04/09/2026",
        hora_entrada: `${String(8 + (i % 6)).padStart(2, "0")}:30`,
        fecha_salida: "04/09/2026",
        hora_salida: `${String(16 + (i % 6)).padStart(2, "0")}:30`,
        habitacion: pick(HABITACIONES, i),
    }
})

const contarPor = (rows: TablaRegistroHuesped[], getter: (r: TablaRegistroHuesped) => string | null) => {
    const conteo = rows.reduce<Record<string, number>>((acc, r) => {
        const key = getter(r)
        if (key) {
            acc[key] = (acc[key] || 0) + 1
        }
        return acc
    }, {})
    return Object.entries(conteo)
        .map<ConteoPorValor>(([label, total]) => ({ label, total }))
        .sort((a, b) => b.total - a.total)
}

export const getRegistroHuespedesDashboard = (rows: TablaRegistroHuesped[]): Dashboard => {
    const titulares = rows.filter((r) => r.tipo_huesped === TipoHuesped.titular).length
    return {
        total_registros: rows.length,
        total_titulares: titulares,
        total_acompanantes: rows.length - titulares,
        por_genero: contarPor(rows, (r) => r.genero),
        por_nacionalidad: contarPor(rows, (r) => r.nacionalidad),
        por_tipo_documento: contarPor(rows, (r) =>
            r.tipo_documento === TipoDocumentoHuesped.otro ? null : r.tipo_documento
        ),
    }
}
